import Combine from "../../components/Combine/Combine";
import QirahatBook from "./QirahatBook";

const Qirahat = () => {
  return (
    <Combine>
      <QirahatBook />
    </Combine>
  );
};

export default Qirahat;
